export type tAuthView =
  | 'start'
  | 'mail_sign_in'
  | 'verify_otp_email'
  | 'sms_sign_in'
  | 'verify_otp_sms';

export const PROVIDER_PARAM = 'provider';

export function initialAuthViewFromUrl(
  search: string = window.location.search
): tAuthView {
  const provider = new URLSearchParams(search).get(PROVIDER_PARAM);
  switch (provider) {
    case 'email':
      return 'mail_sign_in';
    case 'sms':
      return 'sms_sign_in';
    default:
      return 'start';
  }
}
